import React, {Suspense} from "react";
import ErrPage from "../../../../../Common/pages/ErrPage";
import LoadingContainer from "../../../../../Common/component/LoadingContainer/LoadingContainer";

/*
import DemoAdminLogin from "../../../../../Docuwiz-service/DEMO/admin/login/AdminLogin";
import PostechAdminLogin from "../../../../../Docuwiz-service/POSTECH/admin/login/AdminLogin";
import BusanpaAdminLogin from "../../../../../Docuwiz-service/BUSANPA/admin/login/AdminLogin";
 */

const AdminLoginPage = () =>
{
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const ComponentAdminLogin = React.lazy(()=>import(`../../../../../Docuwiz-service/Customer/${serviceCode}/admin/login/AdminLogin`))

    /*
    switch (serviceCode) {
        case 'DEMO':
            return <DemoAdminLogin serviceCode={`${serviceCode}LI`} />;
        case 'POSTECH':
            return <PostechAdminLogin serviceCode={`${serviceCode}LI`} />;
        case 'BUSANPA':
            return <BusanpaAdminLogin serviceCode={`${serviceCode}LI`} />;
        default:
            return <ErrPage errCode={9999} />;
    }

     */
    return ComponentAdminLogin ?    <Suspense fallback={<LoadingContainer message="Loading Modules.." />}>
                                        <ComponentAdminLogin serviceCode={`${serviceCode}LI`} />
                                    </Suspense>
                                    :     <ErrPage errCode={9999} />;
}
export default AdminLoginPage;